import COM from './ViewportProgress'

export default COM
